import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageSeo } from '@/hooks/usePageSeo';

const SECTIONS = [
  {
    icon: 'ri-focus-3-line',
    title: '网站定位',
    paragraphs: [
      '小仓优子资料库是一个专注于演员小仓优子的信息聚合站点，致力于为她提供一个清晰、完整的线上资料入口。',
      '我们希望以专业、详实的方式，把分散的信息整理成便于查阅的档案，让影迷、媒体与行业人士都能快速了解她的作品与近况。',
    ],
  },
  {
    icon: 'ri-layout-masonry-line',
    title: '内容范围',
    paragraphs: [
      '本站内容主要包含四个板块：影视作品（电影与电视剧）、新闻动态（活动资讯与媒体专访）、演员简介（个人资料与获奖情况）以及相关影像资讯。',
      '作品与资讯会持续整理更新，力求做到标题、封面与资料之间的信息一致，方便读者对照查阅。',
    ],
  },
];

export default function About() {
  usePageSeo({
    title: '关于网站_小仓优子资料库说明与免责声明',
    description:
      '了解小仓优子资料库的网站定位、内容范围、联系方式说明以及版权与免责声明，帮助你更好地使用本站提供的演员资料与资讯。',
    keywords: '小仓优子资料库,关于网站,免责声明,版权说明',
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <section className="w-full bg-gradient-to-br from-secondary-50 via-background-50 to-primary-50 border-b border-background-200">
          <div className="w-full px-4 md:px-8 py-10 md:py-14">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于网站' }]} />
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-5">关于本站</h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4 max-w-3xl">
              这里说明了本站的定位、内容范围、联系方式与免责声明。我们希望它是透明、克制且有温度的，也欢迎你在这里读完每一段说明。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="grid md:grid-cols-2 gap-5 md:gap-6">
            {SECTIONS.map((section) => (
              <div key={section.title} className="p-6 md:p-7 rounded-lg bg-background-100 border border-background-200">
                <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${section.icon} text-2xl`}></i>
                </span>
                <h2 className="font-heading text-lg md:text-xl text-foreground-950 mt-5">{section.title}</h2>
                {section.paragraphs.map((p, i) => (
                  <p key={i} className="text-sm text-foreground-700 leading-loose mt-3">
                    {p}
                  </p>
                ))}
              </div>
            ))}
          </div>

          <div className="mt-6 p-6 md:p-8 rounded-lg bg-background-100 border border-background-200">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-mail-send-line text-xl"></i>
              </span>
              <h2 className="font-heading text-lg md:text-xl text-foreground-950">联系方式与留言建议</h2>
            </div>
            <p className="text-sm text-foreground-700 leading-loose mt-4">
              本站为演示性质的资料站，暂不提供真实的联系方式与留言通道。若你在浏览过程中发现内容有误，或希望补充某部作品、某条资讯，欢迎在未来正式上线后通过官方渠道与我们联系。
            </p>
            <p className="text-sm text-foreground-700 leading-loose mt-3">
              我们珍视每一条建议，也会认真对待每一处细节。在正式版本中，这里将开放留言与反馈入口，敬请期待。
            </p>
          </div>

          <div className="mt-6 p-6 md:p-8 rounded-lg bg-background-100 border border-background-200">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-secondary-200 text-secondary-900 flex items-center justify-center">
                <i className="ri-shield-check-line text-xl"></i>
              </span>
              <h2 className="font-heading text-lg md:text-xl text-foreground-950">版权与免责声明</h2>
            </div>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700 leading-loose">
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2.5"></i>
                <span>本站为演示站点，页面内的文字、图片及相关资料均为虚构示例或授权素材，仅用于展示用途。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2.5"></i>
                <span>站内所涉及的姓名、作品、奖项等信息与现实中的任何个人或机构无关，如有雷同纯属巧合。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2.5"></i>
                <span>本站不对因使用站内信息而造成的任何直接或间接损失承担责任，内容仅供参考。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2.5"></i>
                <span>如需引用本站内容，请注明出处；若涉及版权问题，请通过正式渠道与我们取得联系。</span>
              </li>
            </ul>
          </div>

          <div className="mt-10 flex justify-center">
            <Link
              to="/"
              className="inline-flex items-center gap-1 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}